import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Outlet, Navigate, useParams } from 'react-router-dom';
import { AppSidebar } from '@/components/app-sidebar';
import { BottomNav } from '@/components/bottom-nav';
import { Toaster } from '@/components/ui/sonner';
import ProductMapRoute from '@/routes/product-map';
import PriceListRoute from '@/routes/price-list';
import ReportsListRoute from '@/routes/reports-list';
import ReportDetailRoute from '@/routes/report-detail';
import SharedReportRoute from '@/routes/shared-report';
import AdminImportRoute from '@/routes/admin-import';
import { PlaceholderRoute } from '@/routes/placeholder';
import { getBrands, type BrandStat } from '@/lib/api';

export default function App() {
  const [brands, setBrands] = useState<BrandStat[]>([]);

  useEffect(() => {
    let cancelled = false;
    getBrands()
      .then((b) => !cancelled && setBrands(b))
      .catch((err) => console.error('Brands load failed:', err));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        {/* Public read-only share — KHÔNG sidebar, KHÔNG nav */}
        <Route path="/share/:token" element={<SharedReportRoute />} />

        {/* Internal layout — sidebar + main outlet */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<ProductMapRoute brands={brands} onBrandsLoaded={setBrands} />} />
          <Route path="/table" element={<PriceListRoute brands={brands} onBrandsLoaded={setBrands} />} />
          <Route path="/reports" element={<ReportsListRoute brands={brands} />} />
          <Route path="/reports/:id" element={<ReportDetailRoute />} />
          {/* Legacy live brand report — redirect to filtered list (Phase 6 consolidation) */}
          <Route path="/report/:brand" element={<LegacyBrandRedirect />} />
          <Route path="/admin/import" element={<AdminImportRoute />} />
          <Route path="*" element={<PlaceholderRoute title="404" description="Trang không tồn tại" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function LegacyBrandRedirect() {
  const { brand } = useParams<{ brand: string }>();
  const target = brand ? `/reports?brand=${encodeURIComponent(brand)}` : '/reports';
  return <Navigate to={target} replace />;
}

function AppLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebar className="hidden md:flex print:hidden" />
      <main className="flex-1 overflow-x-hidden pb-16 md:pb-0">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
